<template>
    <div>
        <h1>Pathway Clusters</h1>
        <!-- <hr/> -->
        <fieldset :disabled="formDisabled">
            <b-row>
                <b-col>
                    <b-table v-model="tableValues"
                             bordered
                             striped
                             hover
                             responsive
                             outlined
                             small
                             class="info-text"
                             :fields="pathwayClusterFields"
                             :items="pathwayClusterItems"
                             show-empty
                             empty-text="There are currently no records to show."
                    >
                        <template
                            v-if="needsToShowPrevious"
                            v-slot:cell(previous)="data"
                        >
                            <b-form-checkbox
                                :key="data.index + 99"
                                v-model="previousCheckedItems"
                                name="previous-checked"
                                size="lg"
                                disabled
                                :value="data.item"
                            />
                        </template>

                        <template
                            v-slot:head(actions)="data"
                        >
                            <template v-if="isReviewer">
                                Current
                            </template>
                            <template v-if="isApplicant">
                                <b-button size="sm" class="mr-0" @click="toggleAllSelected">
                                    {{ allSelected ? 'Unselect' : 'Select' }} All
                                </b-button>
                            </template>
                        </template>

                        <template v-slot:cell(actions)="data">
                            <b-form-checkbox
                                :key="data.index"
                                v-model="checkedItems"
                                size="lg"
                                name="checked"
                                :value="data.item"
                                @click.native.stop
                            />
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </fieldset>
        <hr>
        <b-row>
            <b-col>
                <module-actions
                    :is-loading="isSaving"
                    background-color="#006438"
                    @saveForm="saveForm"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Arc, Log } from '$Shared/@arc/vue-arc';

export default {
    name: 'PathwayCluster',

    props: {
        formDisabled: { type: Boolean, default: true }
    },

    data() {
        return {
            form: {},
            checkedItems: [],
            allSelected: false,
            tableValues: [],
            previousCheckedItems: [],
            isSaving: false
        };
    },

    computed: {
        ...mapGetters({
            proposalData: 'proposal/proposalData',
            moduleData: 'module/moduleData',
            moduleDataPrevious: 'module/moduleDataPrevious',
            pathwayClusterItems: 'ref/global/pathwayClusters',
            perkinsPerformance: 'application/perkinsPerformance',
            needsToShowPrevious: 'review/needsToShowPrevious',
            isReviewer: 'auth/isReviewer',
            isApplicant: 'auth/isApplicant',
            previousProposalPathwayClusters: 'review/previousProposalPathwayClusters'
        }),

        payload() {
            return {
                content: [...this.savedItems]
            };
        },

        pathwayClusterFields() {
            let fields = [
                { key: 'actions', label: '' },
                { key: 'cluster_id', label: 'Cluster ID' },
                { key: 'cluster_name', label: 'Cluster　Name' },
            ];

            if (this.previousProposalPathwayClusters) {
                fields.unshift({ key: 'previous' });
            }

            return fields;
        },

        savedItems() {
            let itemArray = [];
            if (this.checkedItems) {
                this.checkedItems.forEach(item => {
                    let prop = {};
                    prop.cluster_id = item.cluster_id;
                    prop.cluster_name = item.cluster_name;
                    itemArray.push(prop);
                });
            }
            return itemArray;
        },

        moduleDataContent() {
            let contentArray = [];
            if (this.moduleData.content) {
                this.moduleData.content.forEach(item => {
                    if (this.pathwayClusterItems) {
                        this.pathwayClusterItems.forEach(cluster => {
                            if (
                                item.cluster_id ===
                                cluster.cluster_id
                            ) {
                                contentArray.push(cluster);
                            }
                        });
                    }
                });
            }
            return contentArray;
        },
    },

    watch: {
        checkedItems(a) {
            return this.tableValues.length === a.length;
        },
    },

    async created() {
        if (this.moduleDataContent) {
            this.checkedItems = [...this.checkedItems, ...Arc.Objects.clone(this.moduleDataContent)];
        }
        if (this.previousProposalPathwayClusters) {
            this.previousCheckedItems = [
                ...this.previousCheckedItems,
                ...Arc.Objects.clone(this.previousProposalPathwayClusters)
            ];
        }
    },

    methods: {
        toggleAllSelected() {
            this.allSelected = !this.allSelected;
            this.checkedItems = (this.allSelected) ? this.tableValues : [];
        },

        saveForm() {
            this.isSaving = true;
            this.$store.dispatch('module/saveModule', { ...this.payload })
                .then((response) => {
                    this.isSaving = false;
                    Log.debug(response, `COMPONENT:${this.name} -> Save module response:`);
                })
                .catch((arcAlert) => {
                    this.isSaving = false;
                });
        }
    }
};
</script>

<style scoped lang="scss">
@import "$StyleVars";

h1 {
    font-size: 1.5rem;
    text-align: left;
    font-weight: bold;
    color: $ace-purple;
}
</style>
